import { useContext } from 'react';
import AzureAuthContext from '../contexts/azure_auth_context.ts';

export const useAzureAuth = () => useContext(AzureAuthContext);
